import React from 'react';
import { useClearRefinements } from 'react-instantsearch';

const ClearRefinements = () => {
    const { refine, canRefine } = useClearRefinements();

    if (!canRefine) {
        return null;
    }

    return (
        <div className="filters__clear">
            <label className="toggleButton">
                <button
                    className="toggleButton__checkbox js-search-filter-clear"
                    onClick={() => {
                        refine();
                    }}
                />
                <span className="toggleButton__label toggleButton__label--no-padding -clear">Clear All Filters</span>
            </label>
        </div>
    );
};

export default ClearRefinements;
